import { useContext } from 'react';
import { ModalContext } from './internal/context';
export var useModal = function useModal() {
  var modalContext = useContext(ModalContext);
  if (modalContext == null) {
    throw Error('@atlaskit/modal-dialog: Modal context unavailable – this component needs to be a child of ModalDialog.');
  }
  return modalContext;
};